export default __webpack_public_path__ + "static/media/vid10.59c59e1b.mp4";